module.exports = __webpack_public_path__ + "static/MaximeHerkunftBottleshowLogo-f41e2272c12bcbe0aef014778974c079.jpeg";